export const getCurrentModal = ({ ui }) => ui.layout.currentModal;
